import { appLocales } from "application/constants/app-constants";
import { split, startsWith, filter, length } from "ramda";

export default function getNavLocale() {
  // const appLang = split("-", navigator.language || navigator.userLanguage)[0];
  // const appLocalesFiltered = filter(loc => startsWith(appLang, loc), appLocales);
  // if (length(appLocalesFiltered) > 0) {
  //   return appLocalesFiltered[0];
  // }
  return "en-US";
}
